import { memo } from 'react';
import TooltipDescription from './TooltipDescription';
import { shortQuantity } from '../../utils/formatNumbers';
import { formatearNumeroConComas } from 'views/Components/Shared/utils/formatNumbers';

const ShortLargeValues = memo(({ value, field }) => {
	if (!value) {
		return 0;
	}

	if (value > 1000000) {
		return (
			<TooltipDescription
				description={formatearNumeroConComas(
					field === 'gmv_usd' ? Math.floor(value) : Math.floor(value * 10) / 10
				)}
				title={shortQuantity(value, field)}
			/>
		);
	}

	return formatearNumeroConComas(
		field === 'gmv_usd' ? Math.floor(value) : Math.floor(value * 10) / 10
	);
});

export default ShortLargeValues;
